import ProjectBody from '../../component/layout/projectBody'

function ProjectDisplay() {
  return (
    
      <ProjectBody />
    
  )
}

export default ProjectDisplay
